import Card from "./Card";
import React from "react";
import "../assets/css/style.css";
import Web3 from "web3";
import { useEffect } from "react";
import { supportedNftCollectionAddresses, wearListContractABI, wearNftContractAddress } from "../utils/interact";
import { useState } from "react";
import axios from "axios";
// import data from "../data/SalesNft";

  let provider = window.web3.currentProvider;
const web3 = new Web3(provider);



export default function SalesNFT(props) {
  const [nfts, setNfts] = useState([]);

  useEffect(() => {
    getWalletNfts()
  }, [props.walletAccount])
  

  const getWalletNfts = async (nftCollectionAddress) => {
    supportedNftCollectionAddresses.forEach(async (address, index) => {
      const wearListContract = new web3.eth.Contract(
        wearListContractABI,
        address
      )
      if(props.walletAccount || props.walletAccount !== ""){
        const accountBalance = await wearListContract.methods.balanceOf(props.walletAccount).call();
        for (let index = 0; index < accountBalance; index++) {
          const tokenId = await wearListContract.methods.tokenOfOwnerByIndex(props.walletAccount, index).call();
          const tokenUrl = await wearListContract.methods.tokenURI(tokenId).call();
          setNfts(current => [...current, {'id': tokenId, 'imgUrl': tokenUrl, nftCollectionAddress: address}]);
        }
      }

    })
  }

    return (
      <section className="cards mb-5">
        {nfts.map((data) => (
          <Card imgId={data.id} image={data.imgUrl} key={data.id} walletAccount={props.walletAccount} nftCollectionAddress={data.nftCollectionAddress}/>
        ))}
      </section>
    );
  }
